import { graphql } from "@/graphql/generated";

export const getStoredViewListQueryDocument = graphql(/* GraphQL */ `
  query GetStoredViewList($input: GetStoredViewListInput!) {
    storedViewList(getStoredViewListInput: $input) {
      ...StoredViewFields
    }
  }
`);

export const createStoredViewMutationDocument = graphql(/* GraphQL */ `
  mutation CreateStoredView($input: CreateStoredViewInput!) {
    createStoredView(createStoredViewInput: $input) {
      ...StoredViewFields
    }
  }
`);

export const updateStoredViewMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateStoredView($input: UpdateStoredViewInput!) {
    updateStoredView(updateStoredViewInput: $input) {
      ...StoredViewFields
    }
  }
`);

export const deleteStoredViewMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteStoredView($input: DeleteStoredViewInput!) {
    deleteStoredView(deleteStoredViewInput: $input) {
      ...StoredViewFields
    }
  }
`);
